import type { JwtPayload } from "./JwtPayload"

export const getUserOwnMarketplace = (claims: JwtPayload): string | undefined => claims["ppn:marketplace"] || undefined

export const getUserManagedMarketplaces = (claims: JwtPayload): string[] | undefined => {
	const managedMarketplaces = (claims["ppn:marketplaceManager"] ?? "")
		.split(",")
		.map((value) => value.trim().toLocaleLowerCase())
		.filter((value) => value.length > 0)

	return managedMarketplaces.length > 0 ? managedMarketplaces : undefined
}
